import { Global } from '@emotion/react'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from './theme'

export function MuiThemeProvider({
	children,
}: Readonly<{ children: React.ReactNode }>) {
	return (
		<ThemeProvider theme={theme}>
			<Global
				styles={{
					html: {
						fontFamily: theme.typography.fontFamily,
					},
					body: {
						margin: 0,
						padding: 0,
						boxSizing: 'border-box',
						display: 'flex',
						flexDirection: 'column',
						fontFamily: theme.typography.fontFamily,
					},
					'button, input, select, textarea': {
						fontFamily: 'inherit',
					},
					'*': {
						boxSizing: 'inherit',
					},
					'#app': {
						display: 'contents',
					},
				}}
			/>
			{children}
		</ThemeProvider>
	)
}
